// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1P0hz","notes":"Notes_notes__1052N"};